import { render, staticRenderFns } from "./ot-calendar-holiday-table-row.vue?vue&type=template&id=0adf73b0&scoped=true&"
import script from "./ot-calendar-holiday-table-row.vue?vue&type=script&lang=ts&"
export * from "./ot-calendar-holiday-table-row.vue?vue&type=script&lang=ts&"
import style0 from "./ot-calendar-holiday-table-row.vue?vue&type=style&index=0&id=0adf73b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf73b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
